import Cookies from "js-cookie";

export default function policyTracking() {
	const init = () => {
		logPageView();
		handleClicks();
	};

	const logPageView = () => {
		const postIdElement = document.querySelector("[data-post-id]");

		if (!postIdElement) return;

		const postId = postIdElement.dataset.postId;
		trackPostId(postId);
	};

	const trackPostId = (postId) => {
		const trackedPostIds = Cookies.get("tracked_post_ids") ?? [];
		const decodedTrackedPostIds =
			trackedPostIds && trackedPostIds.length
				? trackedPostIds.split(",")
				: [];

		if (decodedTrackedPostIds[decodedTrackedPostIds.length - 1] === postId)
			return;

		decodedTrackedPostIds.push(postId);

		const commaSeparatedPostIds = decodedTrackedPostIds.join(",");

		Cookies.set("tracked_post_ids", commaSeparatedPostIds, {
			sameSite: "strict",
			path: "/",
			expires: 1,
		});
	};

	const handleClicks = () => {
		const policies = document.querySelectorAll(".js-policy-download");
		if (!policies || !policies.length) return;

		policies.forEach((policy) => {
			policy.addEventListener("click", (e) => {
				if (!e.currentTarget) return;

				const name = e.currentTarget.dataset.name;

				fetch("/wp-json/lead/v1/policies/", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						policy_name: name,
					}),
					credentials: "same-origin",
				}).catch((error) => {
					console.error("Policy tracking failed:", error);
				});
			});
		});
	};

	init();
}
